var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.38,
    height: 13.376,
    viewBox: "0 0 15.38 15.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M20.8,18.977l5.493-5.493a1.287,1.287,0,1,0-1.82-1.82l-5.493,5.493-5.493-5.493a1.287,1.287,0,1,0-1.82,1.82l5.493,5.493L11.664,24.47a1.287,1.287,0,1,0,1.82,1.82L18.977,20.8,24.47,26.29a1.287,1.287,0,1,0,1.82-1.82Z",
    transform: "translate(-11.285 -11.289)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcon);
export default __webpack_public_path__ + "static/media/no-icon.6e8c65717a857d7fecec46838e88d92a.svg";
export { ForwardRef as ReactComponent };